import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import Grid from '../Grid';
import { CARD_BORDER_RADIUS, CARD_BOX_SHADOW, INNER_CARD_PADDING } from '../../config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGrid = styled(Grid).withConfig({
  displayName: "CardComp__StyledGrid",
  componentId: "sc-15p5h3j-0"
})(["&&{margin:0 0 0 0;}"]);
const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "CardComp__StyledCardWrapper",
  componentId: "sc-15p5h3j-1"
})(["padding:", "px;border-radius:", "px;box-shadow:", ";&&{margin-top:32px;}"], INNER_CARD_PADDING, CARD_BORDER_RADIUS, CARD_BOX_SHADOW);
const CardComp = ({
  children,
  testId
}) => {
  return /*#__PURE__*/_jsx(StyledCardWrapper, {
    children: /*#__PURE__*/_jsx(StyledGrid, {
      "data-test-id": testId,
      children: children
    })
  });
};
export default CardComp;